import React from 'react';
import { Mark } from './styled.js';
export const generateMarks = (min, max, step) => {
    const range = max - min;
    const stepCount = step ? range / step : range;
    const markCount = stepCount + 1;
    return Array.from({ length: markCount }).reduce((acc, _, index) => {
        const markValue = min + (index * range) / (markCount - 1);
        acc[markValue] = React.createElement(Mark);
        return acc;
    }, {});
};
